import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChangedUserGroup, ChangeUserGroupState } from "./types";
import { IUser } from "@/shared/api/users";

const initialState: ChangeUserGroupState = {
    isChangeUserGroupModalOpen: false,
    currentUser: {
        id: "",
        username: "",
        name: "",
        email: "",
        phone: "",
        date_of_birth: "",
        gender: "male",
        balance: 0,
        values: {},
        date_of_registration: "",
        telegram_id: "",
        group: {
            name: ""
        },
        group_id: "",
        role_id: "users",
        role: {
            name: ""
        }
    },
    onSuccess: null
}

interface OpenChangeUserGroupModal {
    data: IUser
    onSuccess?: (group: ChangedUserGroup | null) => void
}

const changeUserGroupSlice = createSlice({
    name: 'changeUserGroup',
    initialState,
    reducers: {
        openChangeUserGroupModal: (state, action: PayloadAction<OpenChangeUserGroupModal>) => {
            state.isChangeUserGroupModalOpen = true
            state.currentUser = action.payload.data
            state.onSuccess = action.payload.onSuccess || null
        },
        closeChangeUserGroupModal: (state) => {
            state.isChangeUserGroupModalOpen = false
        },
    }
})

export default changeUserGroupSlice.reducer
export const { 
    closeChangeUserGroupModal,
    openChangeUserGroupModal
} = changeUserGroupSlice.actions

